"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackViewEnd = trackViewEnd;
const browser_core_1 = require("@datadog/browser-core");
const types_1 = require("../../../types");
function trackViewEnd(lifeCycle, viewEndCb) {
    const viewEndSubscription = lifeCycle.subscribe(5 /* LifeCycleEventType.VIEW_ENDED */, () => {
        viewEndCb({
            timestamp: (0, browser_core_1.timeStampNow)(),
            type: types_1.RecordType.ViewEnd,
        });
    });
    return {
        stop: () => {
            viewEndSubscription.unsubscribe();
        },
    };
}
//# sourceMappingURL=trackViewEnd.js.map